import { render, staticRenderFns } from "./navbarUser.vue?vue&type=template&id=6401a831&"
import script from "./navbarUser.vue?vue&type=script&lang=js&"
export * from "./navbarUser.vue?vue&type=script&lang=js&"
import style0 from "./navbarUser.vue?vue&type=style&index=0&id=6401a831&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports